export const COARSE_POINTER_QUERY = '(pointer: coarse)'

/** Touch-first devices use Enter for newlines and the send button to send. */
export function isTouchDevice(): boolean {
  return typeof window !== 'undefined' && window.matchMedia?.(COARSE_POINTER_QUERY).matches === true
}

/** Touch screens with no mouse to hover: phones and tablets. A touch laptop with a trackpad still hovers. */
export const TOUCH_SCREEN_QUERY = '(hover: none) and (pointer: coarse)'

export const MOBILE_QUERY = '(max-width: 767px)'

/** localStorage, or undefined where the browser refuses access to it (it can throw, e.g. with site data blocked). */
export function localStore(): Storage | undefined {
  try {
    return typeof localStorage === 'undefined' ? undefined : localStorage
  } catch {
    return undefined
  }
}

export function isMobileViewport(): boolean {
  return typeof window !== 'undefined' && window.matchMedia?.(MOBILE_QUERY).matches === true
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
